export default __webpack_public_path__ + "static/media/chair.1353311f.png";